import axios from '~/api/axios';
import { Application } from '~/types/Application';
import {
  AgentActivityLogEntry,
  AgentUpdatedFieldsPayload,
  AgentUpdatedFieldsResponse,
} from '~/types/AgentActivityLog';

export interface NationalAddressResponse {
  postalCode: string;
  buildingNumber: string;
  additionalNumber: string;
  unitNumber: string;
  street: string;
  district: string;
  fullAddress: string;
  merchantName: string;
  latitude: string;
  longitude: string;
  city: string;
  regionName: string;
  isPrimaryAddress: boolean;
  restriction: string | null;
  addressId: string;
  status: string;
}

/**
 * Fetches the SPL National Address for the current merchant.
 *
 * Requires unifiedNumber (entity/unified number) and crNumber (CR number fallback)
 * as query params — the backend uses these to identify the merchant and proxy
 * the request to SPL with its own API key.
 *
 *   - UAT  → mock endpoint, no SPL credentials needed from the UI.
 *   - Prod → backend proxies to SPL with its own credentials.
 */
export const getNationalAddress = (unifiedNumber?: string, crNumber?: string) =>
  axios
    .get<NationalAddressResponse>('/ksa/national-address', {
      params: { unifiedNumber, crNumber },
    })
    .then((res) => res.data);

export const proceedReviewSuccess = () => {
  return axios.post<Application>('/stages/review/success/proceed').then((res) => res.data);
};

export const proceedReviewResubmit = () => {
  return axios.post<Application>('/stages/review/resubmit/proceed').then((res) => res.data);
};

export const retriggerScreening = (payload?: Record<string, any>) => {
  return axios
    .post<Application>('/ksa/review/retrigger-screening', payload ?? {})
    .then((res) => res.data);
};


export const getAgentActivityLog = (stepKey?: string) => {
  return axios
    .get<AgentActivityLogEntry[]>('/ksa/review/agent-activity-log', {
      params: stepKey ? { stepKey } : undefined,
    })
    .then((res) => res.data);
};

export const postAgentUpdatedFields = (body: AgentUpdatedFieldsPayload) => {
  return axios
    .post<AgentUpdatedFieldsResponse>('/ksa/review/agent-updated-fields', body)
    .then((res) => res.data);
};

export const exportAgentActivityLog = () => {
  return axios.get<Blob>('/ksa/review/agent-activity-log/export', {
    responseType: 'blob',
  });
};

export type PosReportFileType = 'registration' | 'bank';

export const exportPosReport = (fileType: PosReportFileType) => {
  return axios.get<Blob>('/ksa/review/pos-report/export', {
    params: { fileType },
    responseType: 'blob',
  });
};
